import { Typography } from '@eventbrite/marmalade';
import styles from './Metric.module.scss';

interface Props {
  value: string | number | null | undefined;
  label: string;
  loading?: boolean;
}

export function Metric({ value, label, loading }: Props) {
  return (
    <div className={styles.root}>
      <Typography variant="body-sm" color="neutral-600" className={styles.label}>
        {label ?? ''}
      </Typography>
      <Typography
        variant="body-md-bold"
        className={`${styles.value} ${loading ? styles.loading : ''}`}
      >
        {value ?? '-'}
      </Typography>
    </div>
  );
}
